/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Login_PromptInputs */

const es_co2_signup_login_prompt = /** @type {(inputs: Signup_Login_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Ya tienes cuenta?`)
};

/**

* @param {Signup_Login_PromptInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_login_prompt = /** @type {((inputs?: Signup_Login_PromptInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Login_PromptInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_login_prompt(inputs)
});